
var objContext = null;
const selectUsers = document.querySelector('#selectUsersAssociations'),
    // selectStore = document.querySelector('#selectStore'),
    // selectState = document.querySelector('#selectState'),
    viewAssociations = document.querySelector('#formAssociations'),
    viewNewAssociation = document.querySelector('#formNewAssociation'),
    formTitle = document.querySelector('#formTitleAssociation'),
    btnNewAssociation = document.querySelector('#add-association'),
    containerStores = document.querySelector('.associations-checks-container'),
    containerEstablishments = document.querySelector('#associations-establishments-container'),
    containerEstablishmentsSelected = document.querySelector('#containerEstablishmentsSelected'),
    containerUsers = document.querySelector('.associations-table-container'),
    btnSaveAssociation = document.querySelector('#btn-save-association'),
    btnClearSearch = document.querySelector('#btnClearSearch'),
    btnCancel = document.querySelector('#btn-cancel');



document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

let arrayChecksSelected = [],
    arrayUsersWithAssociation = [],
    //jsonEnabledEstablishments = [], // Only establishments without association for user selected
    //jsonEstablishmentsByUser = [], // All establishments of all users
    //jsonAssociationsByUser = [], // Only establishments associated for user selected
    dataUsers = [],
    idUserToEdit = '',
    isEditing = false;

// All lists establishments
let allEstablishments = [], // All establishments registered
    allAssociations = [], // Relation [ users - establishments ] for get associations
    temporalEstablishments = [], // Temporal list of establishments
    temporalAssociations = [], // Temporal list of associations (list for update establishments in user selected)
    associationsByUser = [], // Only establishments already associated to an user
    addedEstablishments = [], // Temporal list of enabled establishments selected for get new association
    removedAssociations = []; // Temporal list of associations removed of the user selected
let establishmentsToUser = [], establishmentsAvailabled = []
let addCardEstablishmentAdded = [], addCardEstablishmentSelectedAdded = []

//--- Paginator
let pageNumber = 1,
    pageSize= 10,
    maxPages = 0,
    currentPageSpan = document.querySelector('#currentPage'),
    allPagesSpan = document.querySelector('#allPages'),
    btnNext = document.querySelector('#btnNext'),
    btnPrev = document.querySelector('#btnPrev');

// Buscador
let inputSearchByUser = document.querySelector('#search-user');
let inputSearchByShop = document.querySelector('#searchByStore');

window.addEventListener("load", loadPage);

btnNewAssociation.addEventListener("click", loadViewAddNew)
btnCancel.addEventListener("click", loadViewList)

/************************ LOAD VIEWS ****************************/

function loadPage() {
    loadViewList()
    objContext = JSON.parse(sessionStorage.getItem("context"));

    if (objContext == null)
        location.href = 'index.html';
    else {
        if ((localStorage.getItem('user_type') || "") != "1") {
            location.href = 'index.html';
        }
        else {
            loadEstablismentsByUser();
            loadEstableshmentList();
            loadUsers();
            // loadUsersWithAssociations();
            //loadStates();
            //loadAssociations();
        }
    }
}

function loadViewList(){
    viewAssociations.style = "display:inline-grid";
    viewNewAssociation.style = "display:none";
}

function loadViewAddNew(){
    viewAssociations.style = "display:none";
    viewNewAssociation.style = "display:inline-grid";
}

function loadDetails(e){
    idUserToEdit = e.target.parentNode.parentNode.dataset.id; // Save id user to global variable
    isEditing = true;
    formTitle.innerHTML = 'Detalles de la asociación'
    loadUsers();

    viewAssociations.style = "display:none";
    viewNewAssociation.style = "display:inline-grid";
}

/*********************** API CONECTIONS *****************************/
function loadUsers(){
    selectUsers.innerHTML = '<option value="0" hidden="" selected="">Selecciona un usuario</option>'

    fetch(
        BASE_URLS.Dinny.api + `/users`,
        {
            method: 'GET',
            credentials: 'include'
        }
    ).then(function(response){
        if(response.ok){
            response.json().then(function(users){
                if(users.length > 0){
                    // Add options to select users
                    if(isEditing){
                        users.forEach((element) => {
                            if(element.email.indexOf(idUserToEdit) !== -1){
                                selectUsers.insertAdjacentHTML(
                                    'beforeend',
                                    `<option value='${element.email}' selected>${element.email}</option>`
                                )
                            }else{
                                selectUsers.insertAdjacentHTML(
                                    'beforeend',
                                    `<option value='${element.email}'>${element.email}</option>`
                                )
                            }
                        })
                        getAssociationsByUser(idUserToEdit)
                    }else{
                        users.forEach((element) => {
                            selectUsers.insertAdjacentHTML(
                                'beforeend',
                                `<option value='${element.email}'>${element.email}</option>`
                            )
                        })
                    }
                }
                else{
                    UI.message({title: 'No hay Usuarios registrados', content: 'Es necesario tener usuarios registrados, contacte al administrador', accept: 'Aceptar'}, function(){
                        location.href='index.html';
                    });
                }
            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                    window.location.href = 'login.html'
                }else{
                    alert("Ocurrió un error al cargar los menús.", 'error')
                }
            })
        }
    })
}

function loadUsersWithAssociations(){
    fetch(
        BASE_URLS.Standalone.api + `/user/establishment`,
        {
            method: 'GET',
            credentials: 'include'
        }
    ).then(function(response){
        if(response.ok){
            response.json().then(function(users){
                if(users.length > 0){
                    // Add users to list DOM
                    users = users.map(u => {
                        u.establishments = u.establishments.reduce((acc, item) => {
                            if(!acc.find(i => i.id == item.id)){
                                acc.push(item)
                            }
                            return acc
                        }, [])
                        return u
                    })
                    dataUsers = users;
                    injectAssociationsCardsDOM(users);
                }
                else{
                    UI.message({title: 'No hay Usuarios registrados', content: 'Es necesario tener usuarios registrados, contacte al administrador', accept: 'Aceptar'}, function(){
                        location.href='index.html';
                    });
                }
            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                    window.location.href = 'login.html'
                }else{
                    alert("Ocurrió un error al cargar los menús.", 'error')
                }
            })
        }
    })
}

function loadEstableshmentList(){
    UI.showLoader();
    fetch(
        BASE_URLS.Standalone.api + `/establishments`,
        {
            credentials: 'include'
        }
    ).then(function(response){
        UI.hideLoader();
        if(response.ok){
            response.json().then(function(stores){
                allEstablishments = stores; // Save all establishments in global var

                if(stores.length > 0){
                    containerEstablishments.innerHTML = ''
                    stores.forEach((item) => {
                        addCardEstablishment(item);
                    });
                }
                else{
                    UI.message({title: 'No hay estableciminetos registrados', content: 'Es necesario registrar al menos un estableciminto para asociar.', accept: 'Aceptar'}, function(){
                        location.href='index.html';
                    });
                }
            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                    window.location.href = 'login.html'
                }else{
                    alert("Ocurrió un error al cargar los menús.", 'error')
                }
            })
        }
    })
}

function loadEstablismentsByUser(){
    UI.showLoader();
    fetch(
        BASE_URLS.Standalone.api + `/user/establishment`,
        {
            credentials: 'include'
        }
    ).then(function(response){
        UI.hideLoader();
        if(response.ok){
            response.json().then(function(stores){
                if(stores.length > 0){
                    //jsonEstablishmentsByUser =  stores
                    allAssociations = stores // Save relation [ user - establishments ] in global var
                    loadUsersWithAssociations();
                }
                else{
                    UI.message({title: 'No hay estableciminetos registrados', content: 'Es necesario registrar al menos un estableciminto para asociar.', accept: 'Aceptar'}, function(){
                        location.href='index.html';
                    });
                }
            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                    window.location.href = 'login.html'
                }else{
                    alert("Ocurrió un error al cargar los establecimientos asociados.", 'error')
                }
            })
        }
    })
}

function getTotalAssociationsByUser(userEmail){
    let totalEstablishments = 0 ;
    for(let item of allAssociations){
        let name = item.user_id.toLowerCase();

        if(name.indexOf(userEmail.toLowerCase()) !== -1){
            totalEstablishments = item.establishments.reduce((acc,item) => {
                if(!acc.find(i => i.name == item.name)){
                    acc.push(item)
                }
                return acc
            },[]).length;
        }
    }
    return totalEstablishments;
}

function getAssociationsByUser(userEmail){
    clearCardsEstablishmentSelected()
    clearCardsEstablishmentAvailable()
    addCardEstablishmentAdded = []
    addCardEstablishmentSelectedAdded = []
    establishmentsToUser = allAssociations.find(a => a.user_id == userEmail)
    if(!establishmentsToUser){
        establishmentsToUser = []
    } else{
        establishmentsToUser = establishmentsToUser.establishments
    }

    establishmentsToUser.sort((a,b) => a.name > b.name ? 1: -1)
    establishmentsToUser.forEach((shop) => {
        addCardEstablishmentSelected(shop);
    });
    establishmentsAvailabled = allAssociations.find(a => a.user_id == localStorage.getItem('current_user'))
    if(!establishmentsAvailabled){
        establishmentsAvailabled = []
    } else{
        establishmentsAvailabled = establishmentsAvailabled.establishments
    }
    establishmentsAvailabled.sort((a,b) => a.name > b.name ? 1 : -1)
    establishmentsAvailabled.forEach((shop) => {
        addCardEstablishment(shop);
    });
    // let NotAssociated = allEstablishments
    // establishmentsToUser = []
    // establishmentsAvailabled = []
    // fetch(
    //     BASE_URLS.Standalone.api + `/establishments/search?user=${userEmail}&associated=true&req_id=${new Date().getTime()}`,
    //     {
    //         headers:{ "Authorization": localStorage.getItem('session')}
    //     }
    // ).then(function(response){
    //     UI.hideLoader();
    //     if(response.ok){
    //         response.json().then(function(stores){
    //             establishmentsToUser = stores
    //             establishmentsToUser.sort((a,b) => a.name > b.name ? 1 : -1)

    //             if(stores.length > 0){
    //                 stores.forEach((shop) => {
    //                     addCardEstablishmentSelected(shop);
    //                 });
    //             }
    //             else{
    //                 UI.message({title: 'No hay estableciminetos registrados', content: 'Es necesario registrar al menos un estableciminto para asociar.', accept: 'Aceptar'}, function(){
    //                 });
    //             }
    //         });
    //     }else{
    //         response.json().then(function(content){
    //             if(403 == response.status){
    //                 window.location.href = 'login.html'
    //             }else{
    //                 alert("Ocurrió un error al cargar los establecimientos asociados.", 'error')
    //             }
    //         })
    //     }
    // })
    // fetch(
    //     BASE_URLS.Standalone.api + `/establishments/search?user=${userEmail}&associated=false&req_id=${new Date().getTime()}`,
    //     {
    //         headers:{ "Authorization": localStorage.getItem('session')}
    //     }
    // ).then(function(response){
    //     UI.hideLoader();
    //     if(response.ok){
    //         response.json().then(function(stores){
    //             if(stores.length > 0){
    //                 establishmentsAvailabled = stores
    //                 establishmentsAvailabled.sort((a,b) => a.name > b.name ? 1 : -1)
    //                 stores.forEach((shop) => {
    //                     addCardEstablishment(shop);
    //                 });
    //             }
    //             else{
    //                 UI.message({title: 'No hay estableciminetos registrados', content: 'Es necesario registrar al menos un estableciminto para asociar.', accept: 'Aceptar'}, function(){
    //                 });
    //             }
    //         });
    //     }else{
    //         response.json().then(function(content){
    //             if(403 == response.status){
    //                 window.location.href = 'login.html'
    //             }else{
    //                 alert("Ocurrió un error al cargar los establecimientos asociados.", 'error')
    //             }
    //         })
    //     }
    // })

}

function getTemporalEstablishments(){
    // Temporal establishments are establishments no included in associations by user
    // All establishments - Temporal association
    for(let establishment of allEstablishments){

        associationsByUser.forEach((association) => {
            if(association.name.indexOf(establishment.name) == -1){
                list.push(establishment)
            }
        })
    }
}

function getTemporalAssociations(){
    // Temporal associations are establishments associated to an user + addedEstablishments and - removedAssociations
    let list = [];

    // Remove associations deleted
    if(removedAssociations.length > 0){
        for(let association of associationsByUser[0]){
            for(let removed of removedAssociations[0]){
                if(association.name.indexOf(removed.name) < 0 ){ // Si no coincide con los removidos se mantiene la asociación
                    list.push(association)
                }
            }
        }
    }else{
        for(let association of associationsByUser){
            list.push(association)
        }
    }

    clearCardsEstablishmentSelected()
    addCardEstablishment(list)
}

/********************* CLEAR VIEWS ***********************/
function clearCardsEstablishmentSelected(){
    containerEstablishmentsSelected.innerHTML = '';
}
function clearCardsEstablishmentAvailable(){
    containerEstablishments.innerHTML = '';
}

function clearCardsEstablishmentBoth(){
    containerEstablishmentsSelected.innerHTML = '';
    containerEstablishments.innerHTML = '';
}

function clearInputSearchByShop(){
    inputSearchByShop.value = ''
    loadEstableshmentList()
}

/********************** PRINT USERS LIST ****************************/
function injectAssociationsCardsDOM(users){
    if(users.length == 0){
        UI.message({title: 'No hay asociaciones registradas', content: 'Comienza a agregar asociaciones.', accept: 'Aceptar'}, function(){
            modalAddUser.classList.remove('hide');
        });
        document.querySelector('.associations-table-paginator').classList.add('hide');
    }
    else{
        /********************** CREATE PAGINATOR *******************/

        document.querySelector('.associations-table-paginator').classList.remove('hide');
        maxPages = Math.ceil(users.length / pageSize);
        if(pageNumber != maxPages){
            btnNext.disabled = false;
        }
        currentPageSpan.textContent = pageNumber;
        allPagesSpan.textContent = 'de '+ maxPages;
        users = paginate(users,pageSize,pageNumber);

        /**********************************************************/

        let layout=`
            <div class="associations-head">
            <div class="associations-head__email">USUARIO</div>
            <div class="associations-head__associations">ASOCIACIONES</div>
            <div class="associations-head__actions">ACCIONES</div>
            </div>
        `;

        users.forEach(function(user){
            layout += getLayoutAssociationCard(user);
        });

        containerUsers.innerHTML = "";
        containerUsers.insertAdjacentHTML('beforeend', layout);
    }
}

function getLayoutAssociationCard(data){
    let totalAssociations = getTotalAssociationsByUser(data.user_id)

    let layout = `
        <div class="associations-table-item animate__animated animate__fadeIn" data-id="${data.user_id}">
            <div class="w-45 text-steel-80">${data.user_id}</div>
            <div class="w-45 text-steel-80">${totalAssociations}</div>
            <div class="w-10 item-actions">
                <span class="icon-edit" title="Editar usuario" onclick="loadDetails(event)"></span>
                <span class="icon-trash" title="Eliminar usuario" onclick="deletecardAssociation(event)"></span>
            </div>
        </div>
        `;

    return layout;
}

//************************* SEARCH *********************************/
inputSearchByUser.addEventListener('keyup', (e) =>{
    if(inputSearchByUser.value && e.keyCode !== 13 && inputSearchByUser.value.length >= 3){
        sarchByUser(inputSearchByUser.value);
    }
    else{
        if(inputSearchByUser.value == 0){
            resetPaginatorDeliveryZone();
            document.querySelector('#delivery-zone-list').parentNode.querySelector('.header-table-results').classList.remove('hide');
            document.querySelector('#delivery-zone-list').parentNode.parentNode.querySelector('.footer-table-delivery').classList.remove('hide');
            cretaeDeliveryZonesTemplate(arrDeliveryZones);
        }
        else{return}
    }
});

inputSearchByShop.addEventListener('keyup', (e) =>{
    e.preventDefault()
    const found = establishmentsAvailabled.filter(e => e.name.toLowerCase().indexOf(inputSearchByShop.value.toLowerCase()) > -1)
    console.log(found)
    clearCardsEstablishmentAvailable()
    addCardEstablishmentAdded = []
    found.sort((a,b) => a.name > b.name ? 1: -1)
    found.forEach((shop) => {
        addCardEstablishment(shop);
    });
    return false
});

btnClearSearch.addEventListener('click', (e) =>{
    clearInputSearchByShop()
})

function sarchByUser(search){
    let result = [];
    for(let user of dataUsers){
        let name = user.email.toLowerCase();

        if(name.indexOf(search.toLowerCase()) !== -1){
            result.push(user);
        }
    }
    injectAssociationsCardsDOM(result);
}

function searchByShop(search){
    let result = [];
    //UI.showLoader();

    containerEstablishments.innerHTML = '';

    for(let establishment of establishmentsAvailabled){
        let name = establishment.name.toLowerCase();

        if(name.indexOf(search.toLowerCase()) !== -1){
            addCardEstablishment(establishment)
        }
    }
}

/************************** PAGINATION *****************************/
function paginate(array, page_size, page_number) {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function nextPage(){
    pageNumber ++;
    if(pageNumber == maxPages){
        btnNext.disabled = true;
    }
    btnPrev.disabled = false;
    injectAssociationsCardsDOM(dataUsers);
}

function previusPage(){
    pageNumber --;
    if(pageNumber == 1){
        btnPrev.disabled = true;
    }
    btnNext.disabled = false;
    injectAssociationsCardsDOM(dataUsers);
}

/************************ PRINT STORES LIST ***********************/

function addCardEstablishment(establishment){
    if(!addCardEstablishmentAdded.find(e => e.name == establishment.name)){
        addCardEstablishmentAdded.push(establishment)
        let cardEstablishment = createLayoutStore(establishment);
        containerEstablishments.insertAdjacentHTML(
            'beforeend',
            cardEstablishment
        );
    }
}

function addCardEstablishmentSelected(establishment){
    if(!addCardEstablishmentSelectedAdded.find(e => e.name == establishment.name)){
        let cardEstablishment = createLayoutStoreSelected(establishment);
        addCardEstablishmentSelectedAdded.push(establishment)
        containerEstablishmentsSelected.insertAdjacentHTML(
            'beforeend',
            cardEstablishment
        );
        // clearValues();
    }
}


function createLayoutStore(shop){
    let layout = `
        <div class="card-association" data-id="${shop.name}" id="assocStoreId-${shop.id}">
            <div class="card-association__head">
                <div class="card-association__head-title">${shop.name}</div>
                <div class="icons-container" onclick="editAssociation('${shop.id}', '${shop.name.replace(/'/ig, "\\'")}', 'add')">
                    <span class="small-btn-title">Agregar</span>
                    <span class="icon-add-product-60"></span>
                </div>
            </div>
        </div>
    `;
    return layout;
}

function createLayoutStoreSelected(shop){
    let layout = `
        <div class="card-association-selected" data-id="${shop.name} id="assocStoreId-${shop.id}"">
            <div class="card-association__head">
                <div class="card-association__head-title">${shop.name}</div>
                <div class="icons-container" onclick="editAssociation('${shop.id}', '${shop.name.replace(/'/ig, "\\'")}', 'remove')">
                    <span class="small-btn-title">Quitar</span>
                    <span class="icon-trash-20"></span>
                </div>
            </div>
        </div>
    `;
    return layout;
}


function prepareObjectPOST(){
    // let pim = establishmentsToUser.map( e => {
    //     return {
    //         id: `pim-${e.id}`,
    //         name: e.name
    //     }
    // })
    // let raw = establishmentsToUser.map( e => {
    //     return {
    //         id: `${e.id}`,
    //         name: e.name
    //     }
    // })
    // const all = raw.concat(pim)

    let objectToPost = {
        source : "dinny",
        user_id : selectUsers.value,
        stores : establishmentsToUser
    }

    return objectToPost
}

function addAssociation(data){
    UI.showLoader();
    fetch(
        BASE_URLS.Standalone.api + '/user/establishment/',
        {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'include'
    }).then(function(response){
        if(response.ok){
            clearValues();
            location.href = "associations.html";
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    UI.alert("Ocurrió un error al agregar .", 'error')
                }
              });
        }
    }).catch(function(e){
        UI.hideLoader();
        UI.alert('Ocurrió un error.', 'error');
        console.log(e);
    });

}

function editAssociation(id, name, action){
    addCardEstablishmentAdded = []
    addCardEstablishmentSelectedAdded = []
    let establishment = null
    if(action == 'add'){
        establishment = null
        if(establishmentsAvailabled.find(s => s.id == id)){
            establishment = establishmentsAvailabled.filter(s => s.name == name)
            establishmentsAvailabled = establishmentsAvailabled.filter(s => s.name != name)

            establishmentsToUser = establishmentsToUser.concat(establishment)
        }
    }else{
        establishment = null
        if(establishmentsToUser.find(s => s.id == id)){
            establishment = establishmentsToUser.filter(s => s.name == name)
            establishmentsToUser = establishmentsToUser.filter(s => s.name != name)
            establishmentsAvailabled = establishmentsAvailabled.concat(establishment)
        }
    }

    clearCardsEstablishmentSelected()
    clearCardsEstablishmentAvailable()
    establishmentsToUser.sort((a,b) => a.name > b.name ? 1 : -1)
    establishmentsAvailabled.sort((a,b) => a.name > b.name ? 1 : -1)

    establishmentsToUser.forEach(shop => {
        addCardEstablishmentSelected(shop);
    })
    establishmentsAvailabled.forEach(shop => {
        addCardEstablishment(shop);
    })

}

function deleteAssociation(idUser){
    UI.showLoader();
    fetch(
        BASE_URLS.Standalone.api + '/user/establishment/' + idUser,
        {
          method: 'delete',
          credentials: 'include'
    }).then(function(response){
        if(response.ok){
            UI.hideLoader();
            location.href = "associations.html";

        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    UI.alert("Ocurrió un error al eliminar .", 'error')
                }
              });
        }
    }).catch(function(e){
        UI.hideLoader();
        UI.alert('Ocurrió un error.', 'error');
        console.log(e);
    });
}

function deletecardAssociation(e){
    let idUserToDelete = e.target.parentNode.parentNode.dataset.id;

    UI.confirm({
        title: 'Eliminar asociación',
        content: 'Al eliminar las asociaciones del usuario no podrá tener acceso a ninguno de los establecimientos que estén relacionados. ¿Estás seguro de eliminarlo?',
        cancel: 'Cancelar',
        accept: 'Aceptar'
    },function(confirm){
        if(confirm){
            deleteAssociation(idUserToDelete);
        }else{
            loadPage()
        }
    });

}

function createLayoutItemCard(idItem, nameItem){
    let layout = `
        <div class="association-item" data-id="${idItem}" data-name="${nameItem}">
            <i class="icon-associate"></i>
            <span class="ml-05">${nameItem}</span>
        </div>
    `;
    return layout;
}

function createLayoutList(arrayItems){
    let layout = ``;

    arrayItems.forEach((item) => {
        layout = layout + createLayoutItemCard(item.id, item.name);
    });

    return layout;
}



function createLayoutCard(userName, listItems){
    let layout = `
        <div class="card-association" data-id="${userName}">
            <div class="card-association__head">
                <span class="card-association__head-title">${userName}</span>
                <div class="icons-container">
                    <span class="icon-edit" onclick="editAssociation(event)"></span>
                    <span class="icon-trash ml-05" onclick="deletecardAssociation(event)"></span>
                </div>
            </div>
            <div class="card-association__body">
                ${listItems}
            </div>
        </div>
    `;
    return layout;
}

function getStoresChecked(){
    containerStores.querySelectorAll('input[type=checkbox]').forEach((checkbox)=>{
        if(checkbox.checked){
            arrayChecksSelected.push(
                {
                    id : checkbox.id,
                    name : checkbox.value
                }
            );
        }
    });
}

function clearValues(){
    arrayChecksSelected = [];

    containerStores.querySelectorAll('input[type=checkbox]').forEach((checkbox)=>{
        if(checkbox.checked){
            checkbox.checked = false;
        }
    });

}

btnSaveAssociation.addEventListener("click", () =>{
    if(selectUsers.value == 0){
        UI.alert("Selecciona algún usuario sin asociaciones.", "warning");
    }
    else{
        getStoresChecked();

        if(establishmentsToUser.length != 0){
            let checkUsername = arrayUsersWithAssociation.indexOf(selectUsers.value);
            let btnSave = document.querySelector('#btn-save-association');

            if(checkUsername != -1 && btnSave.textContent != "Actualizar asociación"){
                UI.alert("El usuario seleccionado ya tiene una asociación. Puedes editarla desde su tarjeta.", "warning");
            }
            else{
                const postData = prepareObjectPOST()
                addAssociation(postData);
            }
        }
        else{
            UI.alert("Selecciona por lo menos 1 establecimiento.", "warning");
        }

    }
});

selectUsers.addEventListener("change", () => {
    getAssociationsByUser(selectUsers.value);
});

//-- Paginator
btnPrev.addEventListener("click", previusPage);
btnNext.addEventListener("click", nextPage);
